<template>
    <div class="remarks">
        <div class="remarks-head">
            <div class="title">备注：</div>
            <div class="btn">
                <van-button type="info" :color="edit.show.length ? '#666' : ''" size="mini" @click="!edit.show.length ? onEditShow() : onEditHide()" :disabled="!edit.submit">{{edit.show.length ? '取消' : '添加'}}</van-button>
            </div>
        </div>
        <van-collapse v-model="edit.show" :border="false">
            <van-collapse-item name="1">
                <template #title></template>
                <template #icon></template>
                <div class="remarks-edit">
                    <div class="edit-top">
                        <van-radio-group v-model="edit.visibility">
                            <van-radio :name="0" icon-size="16px">公开</van-radio>
                            <van-radio :name="1" icon-size="16px">私有</van-radio>
                        </van-radio-group>
                        <div class="input-box">
                            <van-field v-model="edit.content" placeholder="请输入备注内容（100字以内）" clearable :maxlength="100" show-word-limit @keyup.enter="onEditSubmit()"></van-field>
                            <van-button type="info" size="default" :loading="!edit.submit" plain @click="onEditSubmit()">确认</van-button>
                        </div>
                    </div>
                </div>
            </van-collapse-item>
        </van-collapse>
        <div class="remarks-body">
            <div class="remarks-list">
                <div class="item" :class="{active: edit.id == item.id}" v-for="(item, index) in table.list" :key="index">
                    <div class="item-top">
                        <div class="name">
                            <span>{{item.refUserName}}{{table.roles[item.refUserNo.replace(/^([a-z]+)?(.*)?/i, '$1')]}}</span>
                            <span class="tag" :class="{private: item.visibility == 1}" v-if="item.refUserNo == edit.refUserNo">{{item.visibility == 1 ? '私有' : '公开'}}</span>
                        </div>
                        <div class="time">{{item.modifyTime || item.createTime}}</div>
                    </div>
                    <div class="item-bottom">
                        <div class="content">{{item.content}}</div>
                        <div class="more">
                            <van-popover v-model="item.more" trigger="click" :actions="item.refUserNo != edit.refUserNo ? [] : onMoreOptions(item)" @select="onDropdown($event, item)" placement="bottom-end" :offset="[23, 8]" :disabled="item.refUserNo != edit.refUserNo">
                                <template #reference>
                                    <div class="more-box" :class="{dis: item.refUserNo != edit.refUserNo}">
                                        <van-icon name="ellipsis" color="" />
                                    </div>
                                </template>
                            </van-popover>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'remarks',
    components: {

    },
    props: {
        askNo: String
    },
    data() {
        return {
            table: {
                list: [],
                loading: false,
                roles: {
                    YS: '医生',
                    SHYS: '药师',
                    ZL: '医助',
                    YD: '药房'
                }
            },
            edit: {
                show: [],
                id: '',
                visibility: 0,
                content: '',
                submit: true,
                refUserNo: ''
            },
            more: {
                actions: [
                    {
                        text: '编辑',
                        type: 'edit'
                    },
                    {
                        text: '删除',
                        type: 'delete'
                    },
                    {
                        text: '设为仅自己可见',
                        type: 'private'
                    },
                    {
                        text: '设为全部人可见',
                        type: 'public'
                    }
                ]
            }
        }
    },
    computed: {

    },
    mounted() {
        this.edit.refUserNo = this.$store.state.assistantNo;
        this.onDataGet();
    },
    methods: {
        onDataGet() {
            if (!this.askNo) return false;
            this.table.loading = true;
            let send = {
                refNo: this.askNo
            }
            this.$axios.get('/misc-service/remark/listRemarkByRefNo', {
                params: send
            }).then(({ data }) => {
                this.table.list = data.map((item) => {
                    item.more = false;
                    return item;
                });
                this.table.loading = false;
            }).catch(() => {
                this.table.loading = false;
            });
        },
        onEditHide() {
            this.edit.id = '';
            this.edit.show = [];
        },
        onEditShow(row) {
            if (!row) row = {};
            this.edit.visibility = 'visibility' in row ? row.visibility : 0;
            this.edit.content = row.content || '';
            this.edit.id = row.id || '';
            this.edit.show = ['1'];
        },
        onDropdown(event, row) {
            switch (event.type) {
                case 'edit':
                    this.onEditShow(row)
                    break;
                case 'delete':
                    this.onDelete(row);
                    break;
                case 'private': // 私有
                case 'public': // 公开
                    this.edit.id = row.id;
                    this.edit.visibility = event.type == 'private' ? 1 : 0;
                    this.onEditSubmit(true);
                    break;
            }
        },
        onMoreOptions(row) {
            let options = JSON.parse(JSON.stringify(this.more.actions));
            return options.map((item) => {
                if (item.type == 'private') {
                    if (row.visibility == 1) item.disabled = true;
                } else if (item.type == 'public') {
                    if (row.visibility != 1) item.disabled = true;
                }
                return item;
            })
        },
        onEditSubmit(isPrivate) {
            if (!this.edit.submit) return false;
            if (!this.edit.content && !isPrivate) {
                this.$toast.fail('请填写备注')
                return false;
            }
            let send = {
                refNo: this.askNo,
                visibility: this.edit.visibility
            }
            if (!isPrivate) {
                send.content = this.edit.content
            }

            this.edit.submit = false;

            this.$axios[this.edit.id ? 'put' : 'post'](this.edit.id ? '/misc-service/remark/modify/' + this.edit.id : '/misc-service/remark/create', send, {
                headers: {
                    'content-type': 'application/json'
                }
            }).then((data) => {
                if (data.code == 0) {
                    this.$toast.success(this.edit.id ? '修改成功' : '添加成功')
                    this.onEditHide();
                    this.onDataGet();
                } else {
                    this.$toast.fail(data.message)
                }
                this.edit.submit = true;
            }).catch((data) => {
                this.$toast.fail(data.message)
                this.edit.submit = true;
            });
        },
        onDelete(row) {
            this.$dialog.confirm({
                title: '是否确认删除备注?',
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                closeOnClickOverlay: false
            }).then(() => {
                this.$axios.delete('/misc-service/remark/delete/' + row.id).then((data) => {
                    if (data.code == 0) {
                        this.$toast.success('删除成功');
                        this.onEditHide();
                        this.onDataGet();
                    } else {
                        this.$toast.fail(data.message);
                    }
                }).catch((data) => {
                    this.$toast.fail(data.message);
                });
            }).catch(() => {
                
            });
        }
    },
    watch: {
        askNo: 'onDataGet'
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";

.remarks {
    font-size: 14px;

    &-head {
        @include flex(center, space-between);

        .title {
            font-weight: bold;
            font-size: 16px;
        }

        .van-button {
            border-radius: 4px;
        }
    }

    .van-collapse {
        #{$deep} .van-collapse-item__title {
            display: none;
        }

        #{$deep} .van-collapse-item__content {
            padding: 0;
        }
    }

    &-edit {
        margin-top: 10px;

        .van-radio-group {
            @include flex();

            .van-radio {
                margin-right: 10px;

                #{$deep} .van-icon {
                    @include flex(center, center);

                    &::before {
                        content: "";
                        width: 7px;
                        height: 7px;
                        border-radius: 10px;
                        background: #fff;
                    }
                }
            }
        }

        .input-box {
            @include flex(center, space-between);
            margin-top: 10px;

            .van-button {
                flex: none;
                margin-left: 10px;
                padding: 0 10px;
                font-size: 12px;
                height: 30px;
                border-radius: 4px;
            }

            .van-field {
                padding: 0;

                #{$deep} .van-field__value {
                    @include flex();
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    padding: 0 10px;

                    .van-field__body {
                        flex: 1;
                    }

                    .van-field__word-limit {
                        flex: none;
                        margin-left: 10px;
                    }
                }
            }
        }
    }

    &-body {
        margin-top: 15px;
        .item {
            position: relative;
            padding-left: 20px;
            padding-bottom: 15px;

            &::before,
            &::after {
                content: "";
                position: absolute;
                top: 5px;
            }

            &::before {
                left: 0;
                z-index: 2;
                width: 8px;
                height: 8px;
                border-radius: 8px;
                background: #d9d9d9;
            }

            &::after {
                bottom: -5px;
                left: 4px;
                width: 1px;
                background: #d9d9d9;
            }

            &:last-child {
                &::after {
                    display: none;
                }
            }

            &.active {
                &::before {
                    background: #4d86f7;
                }
            }

            &-top {
                @include flex(center, space-between);
                color: #797979;

                .tag {
                    color: #3ec73a;
                    background: #ecffe0;
                    padding: 3px 5px;
                    margin-left: 10px;

                    &.private {
						color: #3388f9;
						background: #ebf8fb;
					}
                }
            }

            &-bottom {
                margin-top: 10px;
                @include flex(center, space-between);
                .content {
					word-break: break-all;
				}

                .more {
                    flex: none;
                    margin-left: 20px;
                    margin-top: -5px;

                    .van-icon {
                        transform: rotate(90deg);
                        font-size: 18px;
                    }

                    &-box {
                        &.dis {
                            color: #ccc;
                            cursor: not-allowed;
                        }
                    }
                }
            }
        }
    }
}
</style>